import type { SerializedStyles } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { SvgGoogle } from '@coursera/coursera-ui/svg';

import SocialButton from 'bundles/authentication-common/components/sso/SSOButton';
import withOAuthSSO from 'bundles/authentication-common/hocs/OAuthSSO';
import useTrackClickButton from 'bundles/authentication-common/hooks/useTrackClickButton';
import withSingleTracked from 'bundles/common/components/withSingleTracked';
import { SSOTypes } from 'bundles/third-party-auth/lib';

import _t from 'i18n!nls/authentication';

type Props = {
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  btnLabel?: string;
  customStyles?: SerializedStyles;
  iconColor?: string;
};

const TrackedSocialButton = withSingleTracked({ type: 'BUTTON' })(SocialButton);

export const Google = React.forwardRef(
  ({ className, disabled = false, onClick, btnLabel, customStyles, iconColor }: Props, ref: React.Ref<HTMLElement>) => {
    const { trackButton } = useTrackClickButton();
    const handleOnClick = () => {
      trackButton({ name: 'signup_with_google' });
      onClick?.();
    };
    return (
      <TrackedSocialButton
        className={className}
        disabled={disabled}
        icon={SvgGoogle}
        iconColor={iconColor}
        customStyles={customStyles}
        onClick={handleOnClick}
        trackingName="continue_with_google_auth_btn"
        _refAltAsTrueRef={ref}
      >
        {btnLabel ?? (
          <Typography2 component="span" variant="actionSecondary" color="inherit">
            {_t('Continue with Google')}
          </Typography2>
        )}
      </TrackedSocialButton>
    );
  }
);
Google.displayName = 'Google';

export default withOAuthSSO(Google, SSOTypes.GOOGLE);
